import { ShieldCheck, Award, Microscope, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { STATS, IMAGES } from "@/data/content";

const REASONS = [
  { icon: ShieldCheck, title: "Laborator acreditat RENAR", text: "Conform standardului SR EN ISO 15189 — rezultate în care ai încredere." },
  { icon: Clock, title: "Rezultate rapide", text: "Multe analize sunt gata în aceeași zi, online sau la recepție." },
  { icon: Microscope, title: "Laborator propriu ultramodern", text: "Echipamente de ultimă generație și personal medical experimentat." },
  { icon: Award, title: "Experiență din 2007", text: "Aproape 20 de ani în slujba sănătății pacienților noștri." },
];

export default function WhyMedas() {
  return (
    <section id="despre" className="py-20 lg:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Stats */}
        <Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 rounded-3xl bg-[#2A2521] p-8 lg:p-10">
            {STATS.map((s) => (
              <div key={s.label} className="text-center" data-testid={`stat-${s.label}`}>
                <div className="font-display text-3xl lg:text-5xl font-extrabold text-white">
                  {s.value}<span className="text-[#DCC79A]">{s.suffix}</span>
                </div>
                <div className="text-white/70 text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <div className="mt-20 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal className="order-2 lg:order-1">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">De ce MEDAS</span>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mt-3">
              O altfel de îngrijire medicală. Desăvârșită prin fiecare detaliu.
            </h2>
            <p className="text-slate-600 mt-4 text-lg">
              De la primul telefon până la rezultatul final, totul este gândit să fie limpede, rapid și impecabil.
            </p>
            <div className="mt-8 grid sm:grid-cols-2 gap-5">
              {REASONS.map((r, i) => (
                <div key={r.title} className="flex gap-3">
                  <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                    <r.icon className="w-5 h-5 text-[#A6823B]" />
                  </span>
                  <div>
                    <h4 className="font-display font-bold text-slate-900 text-base">{r.title}</h4>
                    <p className="text-sm text-slate-500 mt-1">{r.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1} className="order-1 lg:order-2">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl shadow-[#A6823B]/15 aspect-[4/3]">
                <img src={IMAGES.microscope} alt="Echipamente de laborator MEDAS" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -right-4 lg:-right-6 rounded-2xl overflow-hidden shadow-xl border-4 border-white w-36 h-36 lg:w-44 lg:h-44">
                <img src={IMAGES.clinic} alt="Clinică MEDAS" className="w-full h-full object-cover" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
